import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          分类索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#updates"
              className="group flex items-center gap-3 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <span className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}